module.exports = __webpack_public_path__ + "static/media/addBlack.49e57622.svg";